import axios from "axios";
import {Space} from "../Models/Space";
import {API_GET_ALL_SPACES} from "../Config/Uri";

export interface GetAllSpacesResult {
    error: string | null;
    data: Space[] | null;
}

export function startGetAllSpaces(): Promise<GetAllSpacesResult> {
    const url = API_GET_ALL_SPACES();
    return axios({ url: url, method: "GET", withCredentials: true })
        .then(res => {
            if (res.data != null) {
                const data = JSON.parse(JSON.stringify(res.data)) as Space[];
                return {
                    error: null,
                    data: data
                } as GetAllSpacesResult;
            }
            return {
                error: null,
                data: null
            } as GetAllSpacesResult;
        })
        .catch(err => {
            if (err.response) {
                // client received an error response (5xx, 4xx)
                return Promise.reject({
                    error: err.response.data.message,
                    data: null
                } as GetAllSpacesResult);
            } else if (err.request) {
                // client never received a response, or request never left
                return Promise.reject({
                    error: err.message,
                    data: null
                } as GetAllSpacesResult);
            } else {
                // anything else
                return Promise.reject({
                    error: err.message,
                    data: null
                } as GetAllSpacesResult);
            }
        })
}
